import { DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

export interface ConfirmationDialogProps extends DialogProps {
    title: string;
    description: string;
    onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onConfirm: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function DialogConfirmAction({
    title,
    description,
    onConfirm,
    onCancel,
    ...props
}: ConfirmationDialogProps) {
    return (
        <Dialog maxWidth="xs" {...props}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>{description}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} variant="text" autoFocus>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="error" variant="outlined">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}
